import React from 'react';
import ConfirmationForm from '../ConfirmationForm';

// Renderer for the submit-ticket-preflight result: the drafted ticket as a review-and-confirm card.
// The Submit button posts the confirmation message; the model then files it via open-support-ticket.
export default function SubmitTicketPreflight({ data, fields, isLast }) {
  return (
    <ConfirmationForm
      data={data}
      fields={fields}
      isLast={isLast}
      title="Review the support ticket to be filed"
      confirmLabel="Submit"
      confirmMessage="Confirmed — file this ticket now."
    />
  );
}
